import { SHTableCell, SHTypography } from "@components/design-systems";
import { useTheme } from "@mui/material";
import { memo } from "react";
import { TableVirtualizationConfigs as Configs } from "../../../../configs";

interface RenderedProductTableTitleProps {
  title?: string;
  fixedWidth?: number;
}

export const RenderedProductTableTitle = memo(
  ({
    title = "Features",
    fixedWidth = Configs.TitleColumnWidth,
  }: RenderedProductTableTitleProps) => {
    const { palette } = useTheme();

    return (
      <SHTableCell
        sx={{
          position: "sticky",
          left: 0,
          height: "100%",
          minWidth: fixedWidth,
          maxWidth: fixedWidth,
          alignItems: "center",
          justifyContent: "center",
          padding: "5px 12px",
          textAlign: "center",
          border: `1px solid ${palette.secondary[100]}`,
          bgcolor: palette.common.white,
          zIndex: 10,
        }}
      >
        <SHTypography
          variant={"subtitle1"}
          lineHeight={"150%"}
          sx={{
            fontWeight: 700,
          }}
        >
          {title}
        </SHTypography>
      </SHTableCell>
    );
  },
);
